import styled, { keyframes } from 'styled-components';
import { NavLink } from 'react-router-dom';
import white from 'sushiweb/tokens/color/white';
import Menu from 'sushiweb/Icons/all/Menu';
import Layout from 'sushiweb/Layout/Layout';
import ProgressBar from 'sushiweb/ProgressBar';
import grey from 'sushiweb/tokens/color/grey';
import Button from 'sushiweb/Button';
import black from 'sushiweb/tokens/color/black';
import green from 'sushiweb/tokens/color/green';
import red from 'sushiweb/tokens/color/red';
import H4 from 'sushiweb/Typography/Heading/H4';
import H6 from 'sushiweb/Typography/Heading/H6';
import Input from 'sushiweb/InputTypes/Input/Input';
import teal from 'sushiweb/tokens/color/teal';
import { uploadErrorStatus } from '../components/constants';

export const tabStyle = {
  justifyContent: 'center',
  fontSize: '16px',
  fontWeight: 400,
  border: '0px',
  paddingLeft: '10px',
};

export const infoTooltipStyle = {
  fontSize: '15px',
  padding: '5px',
  borderRadius: '10px',
  opacity: '0.8',
  width: '200px',
};

export const InstructionText = styled.div`
  font-size: 1.4rem;
  margin-top: 1.6rem;
  color: ${grey.z500};
  p {
    display: inline;
    font-weight: 500;
    font-size: 1.4rem !important;
    color: ${grey.z600};
  }
`;

export const TableHeaderH6 = styled(H6)`
  font-size: 1.5rem;
`;

export const ProgressBarStyled = styled(ProgressBar)`
  height: 3px;
`;

export const DashboardWrapper = styled.div`
  width: calc(100vw - 27rem);
  height: auto;
  position: absolute;
  top: 7.2rem;
  right: 0;
  padding: 4.4rem 4.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--coolgreycoolgrey-50, #f8f9fc);
  color: var(--coolgreycoolgrey-900, #293142);
`;

export const LoggedOutStateWrapper = styled.div`
  width: calc(100vw);
  height: auto;
  top: 7.2rem;
  position: absolute;
  right: 0;
  padding: 4.4rem 4.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--coolgreycoolgrey-50, #f8f9fc);
  color: var(--coolgreycoolgrey-900, #293142);
`;

export const LoggedOutHeaderWrapper = styled.div`
  padding: 10px;
  background: ${props =>
    props.isStagging ? red.z100 : 'var(--coolgreycoolgrey-50, #f8f9fc)'};
  border-bottom: 0.2rem solid ${grey.z200};
  position: fixed;
  top: 0;
  z-index: 10;
  width: calc(100vw);
  height: 7.2rem;
  @media (max-width: 480px) {
    margin-bottom: 0;
  }
`;

export const LoggedOutZFELogoWrapper = styled.div`
  padding: 10px;
`;
export const SpinnerHolder = styled.div`
  width: 100%;
  max-width: 130rem;
  height: 50vh;
  margin: auto;
`;

export const HeadWrapper = styled.div`
  width: 100%;
  max-width: 130rem;
  display: flex;
  justify-content: space-between;
  height: 4.4rem;
  margin-bottom: 0.8rem;
  font-family: Lexend-400;
  font-weight: 400;
`;

export const BreadcrumbHeaderWrapper = styled.div`
  width: 100%;
  max-width: 130rem;
  display: flex;
  justify-content: space-between;
  height: 4.4rem;
  margin-bottom: 0.8rem;
`;

export const ConsumptionHeadWrapper = styled.div`
  width: 100%;
  max-width: 130rem;
  display: flex;
  height: 4.4rem;
  margin-bottom: 0.8rem;
  font-family: Lexend-400;
  font-weight: 400;
  h5 {
    font-weight: 400;
  }
  p {
    padding: 5px;
    color: var(--COOL-GREY-COOL-GREY900, #293142);
    font-size: 15px;
    font-style: normal;
    font-family: Lexend-300;
    font-weight: 300;
  }
`;

export const TabHeadWrapper = styled.div`
  width: 100%;
  max-width: 130rem;
  display: flex;
  justify-content: space-between;
  height: 4.4rem;
  padding: 40px 0px 25px 0px;
  h5 {
    font-family: Lexend-400;
    font-weight: 400;
  }
  div {
    margin-top: -35px;
  }
`;

export const TabWrapper = styled.div`
  width: 100%;
  max-width: 130rem;
  padding: 20px
  flex-shrink: 0;
  border-radius: 20px;
  border: 1px solid var(--coolgreycoolgrey-100, #F2F4F7);
  background: var(--basewhite-000, #FFF);
`;

export const HeaderH4 = styled(H4)`
  margin-right: 2rem;
`;

HeadWrapper.Left = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0 1.4rem;
  cursor: pointer;
  input {
    cursor: pointer;
    width: 1.8rem;
    height: 1.8rem;
  }
  p {
    font-size: 1.6rem;
    color: ${grey.z800};
  }
`;

export const FooterWrapper = styled.div`
  background: ${white};
  padding: 0 2rem;
  border-top: 0.1rem solid ${grey.z200};
  width: 100%;
  position: fixed;
  bottom: 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: 'row-reverse';
`;

export const Footer = styled.div`
  width: 100%;
  max-width: 130rem;
  height: 7.2rem;
  margin: 0 auto;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 4;
`;

export const RightButton = styled(Button)`
  position: absolute;
  right: 0;
`;

export const SearchContainer = styled.div`
  width: 100%;
  max-width: 130rem;
  border: 0.1rem solid ${grey.z200};
  padding: 0.4rem 1.8rem 0.8rem;
  p {
    font-size: 1.6rem;
    color: ${grey.z900};
    margin: 1.2rem 0;
  }
`;

export const SearchContainerV2 = styled.div`
  width: 100%;
  max-width: 130rem;
  padding-left: 20px;
  padding-top: 20px;
  padding-bottom: 5px;
  display: flew;
  justify-content: space-between;
`;

export const StatusFilterAndExportCSVContainer = styled.div`
  display: flex;
`;

export const SearchInput = styled(Input)`
  width: 100%;
  max-width: 500px;
  border-radius: 60px;
  input {
    border: 0.1rem solid ${grey.z200};
    &:focus {
      border-color: ${teal.z400};
    }
  }
`;

export const StyledSearchInput = styled(Input)`
  width: 100%;
  max-width: 500px;
  input {
    border: 0.1rem solid ${grey.z200};
    border-radius: 0.6rem 0 0 0.6rem;
    border-right: none;
    &:focus {
      border-color: ${teal.z400};
    }
`;

export const TableContainer = styled.div`
  width: 100%;
  max-width: 130rem;
  justify-content: space-between;
  align-items: center;
  background: ${white};
  border-top: 0.1rem solid ${grey.z200};
`;

export const TableContainerWithOverflow = styled.div`
  width: 100%;
  max-width: 130rem;
  justify-content: space-between;
  align-items: center;
  background: ${white};
  border-top: 0.1rem solid ${grey.z200};
  & > div {
    overflow: visible;
  }
`;

export const StyledButton = styled(Button)`
  margin-left: 2rem;
`;

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 130rem;
  margin-top: 1.5rem;
  p {
    margin-top: 1.4rem;
    font-size: 1.6rem;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  margin: 2.4rem 0;
  background: ${white};
  border: 0.1rem solid ${grey.z200};
  border-radius: 0.8rem;
  padding: 3.4rem 2.6rem;
  h5 {
    /* margin-bottom: 2.4rem; */
  }
  p {
    font-size: 1.7rem;
  }
`;

const move = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 50px 50px;
  }
`;

export const ConfirmUpload = styled.div`
  -webkit-transition: visibility 0s, opacity 0.2s linear;
  -moz-transition: visibility 0s, opacity 0.2s linear;
  transition: visibility 0s, opacity 0.2s linear;
  opacity: ${props =>
    props.show && !uploadErrorStatus.includes(props.status) ? 1 : 0};
  display: ${props =>
    props.show && !uploadErrorStatus.includes(props.status) ? 'block' : 'none'};
  overflow: hidden;
  width: 600px;
  max-width: 130rem;
  margin-top: 1.8rem;
  margin-left: 1.5rem;
  padding: 2rem 3rem;
  font-weight: 500;
  color: ${props =>
    uploadErrorStatus.includes(props.status) ? red.z700 : green.z700};
  font-size: 1.6rem;
  border-radius: 1rem;
  border: ${props =>
    uploadErrorStatus.includes(props.status)
      ? `0.1rem solid ${red.z400}`
      : `0.1rem solid ${green.z400}`};
  background-color: ${props =>
    uploadErrorStatus.includes(props.status) ? red.z200 : green.z200};
  position: relative;
  &:after {
    display: ${props => (props.progress ? 'block' : 'none')};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
    background-size: 50px 50px;
    animation: ${move} 2s linear infinite;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${props => (props.large ? '-2.4rem' : '0')};
  width: ${props => (props.large ? '66%' : '100%')};
  p {
    font-size: 1.6rem;
    font-weight: 400;
    color: ${grey.z700};
  }
`;

export const ConfirmLabel = styled.div`
  display: flex;
  margin-top: 2.5rem;
  input {
    margin: 0.6rem 1.2rem 0 0;
    cursor: pointer;
    width: 1.8rem;
    height: 1.8rem;
  }
  p {
    font-size: 1.6rem;
    color: ${black};
  }
  a {
    display: contents;
    font-size: 1.6rem;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding: 2rem 2rem;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  // for fitting container btw header for footer
  top: 7.2rem;
  height: calc(
    100vh - 7.2rem - ${({ noFooter }) => (noFooter ? '0rem' : '7.2rem')}
  );

  // aligning content
  position: relative;
`;

// add content
Container.Content = styled.div`
  width: 100%;
  max-width: 130rem;
  margin: auto;
`;

export const StyledLayout = styled(Layout)`
  margin-top: 1.4rem;
`;

export const UploadsContainer = styled.div`
  width: 100%;
  max-width: 130rem;
  margin-top: 0.6rem;
`;

export const TableHeadInfo = styled.div`
  display: inline-flex;
  align-items: baseline;
  width: 100%;
  max-width: 130rem;
  margin-bottom: 1.8rem;
  font-size: 1.7rem;
  font-weight: 500;
  p {
    margin-left: 0.8rem;
    font-size: 1.4rem;
    font-weight: 400;
  }
  input {
    margin-left: 1.6rem;
    font-size: 1.4rem;
    border: 0.05rem solid ${grey.z400};
    border-radius: 0.4rem;
    background: ${white};
    padding: 0.8rem 1.2rem;
  }
`;

export const TabContainer = styled.div`
  padding-top: 7px;
  padding-right: 20px;
  display: flex;
  width: 100%;
  max-width: 130rem;
  border-bottom: 0.1rem solid ${grey.z200};
  justify-content: space-between;
  align-items: center;
`;

export const TableHeadWrapper = styled.div`
  padding: 1.5rem;
`;

export const CalendarIcon = styled(Menu)`
  margin-right: 0.3rem;
`;

export const StyledDiv = styled.div`
  margin-top: 1rem;
  margin-left: 0.5rem;
`;

export const Header = styled.div`
  display: flex;
`;

export const StyledH6 = styled(H6)`
  font-size: 1.4rem;
  color: grey;
`;

export const IconDiv = styled.div`
  padding-left: 30px;
`;

export const LayoutContainers = styled.div`
  width: 100%;
  max-width: 130rem;
  display: flex;
  justify-content: space-between;
`;

export const BreadCrumbWrapper = styled.div`
  width: 100%;
  max-width: 130rem;
  display: flex;
  justify-content: space-between;
`;

export const ActionModalWrapper = styled.div`
  width: 634px;
`;

export const ActionModalInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-size: 1.6rem;
    margin-bottom: 1rem;
    color: ${grey.z900};
  }
`;
ActionModalInputWrapper.HelperText = styled.div`
  font-size: 1.3rem;
  margin-top: 0.8rem;
  color: ${grey.z600};
`;

export const ActionBottomButtonWrapper = styled.div`
  margin-top: 1.5rem;
  display: flex;
  justify-content: space-between;
`;

export const ActionModalStyledInput = styled(Input)`
  margin-top: 1.2rem;
  width: 100%;
`;

export const FormatTimeWrapper = styled.div`
  p {
    font-size: 12px;
  }
`;

export const DottedActionBtnWrapper = styled.div`
  margin-top: -10px;
`;

export const OnlinePaymentHeader = styled.div`
  display: table-column;
  padding: 10px 0px 10px 0px;
  p {
    font-size: 1.7rem;
    font-family: Lexend-300;
  }
  h4 {
    font-size: 2.3rem;
    font-family: Lexend-300;
  }
  #amount {
    font-family: Lexend-400;
  }
`;

export const OnlinePaymentStatusHeader = styled.div`
  display: flex;
  p {
    font-size: 1.7rem;
    font-family: Lexend-300;
  }
  h4 {
    font-size: 2.3rem;
    font-family: Lexend-400;
  }
  #amount {
    font-family: Lexend-400;
  }
`;

export const OnlinePaymentCenterAlign = styled.div`
  text-align: center;
`;

export const RedirectNavlink = styled(NavLink)`
  text-decoration: none;
`;

export const MonthBtn = styled.div`
  display: inline-flex;
  margin: 10px 10px 0px 0px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  border: 0.5px solid
    ${props =>
      props.active
        ? 'var(--RED-RED300, #FFB1C0)'
        : 'var(--COOL-GREY-COOL-GREY200, #e6e9ef)'};
  background: ${props =>
    props.active ? 'var(--RED-RED50, #FFF5F6)' : 'var(--BASE-WHITE000, #fff)'};
  font-size: 14px;
`;

export const TooltipWrapper = styled.div`
  div {
    width: unset;
  }
`;

export const DownloadIconWrapper = styled.div`
  cursor: pointer;
`;

export const CurrentMonthDiscountMsgIcon = styled.div`
  padding: 17px;
`;

export const CurrentMonthConsumptionDiscountWrapper = styled.div`
  width: 100%;
  max-width: 130rem;
  height: 50px;
  flex-shrink: 0;
  border-radius: 16px;
  border: 0.5px solid var(--color-base-yellow-300, #f7d35f);
  background: var(--color-base-yellow-50, #fff9e5);
  display: flex;
  flex-direction: row;
`;

export const CurrentMonthConsumptionDiscountText = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 15px 0px;
  color: var(--color-base-yellow-800, #5f4d11);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
`;

export const CurrentMonthConsumptionDiscountGap = styled.div`
  height: 16px;
`;
